/**
 * Gets the full namespaced name used by vuex.
 * @param {string} namespace Namespace of the store module
 * @param {string} commitOrActionName Name of the mutation or action
 */
export const getNamespaced = (
    namespace: string,
    commitOrActionName: string,
) => {
    return `${namespace}/${commitOrActionName}`;
};
